import { useState } from 'react';
import { TextArea, TextBox } from '../../../shared/controls/form';
import { Form, Formik } from 'formik';

const NoteForm = ({ noteData, handleChangeFormNote, handleSubmit, noteDataEdited, loading }) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <>
      <Formik>
        <Form>
          <div className="col-12 col-md-12">
            <div className="input-container customTextA">
              <TextBox
                isRequired={false}
                label={''}
                name={'title'}
                placeholder={'Add a Title...'}
                value={noteData.title}
                handleChange={handleChangeFormNote}
                maxLength={250}
              />
            </div>
          </div>
          <div className="col-12 col-md-12">
            <div className={`notesDesContainer ${isFocused ? 'focused' : ''}`}>
              <div
                className="input-container"
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
              >
                <TextArea
                  name={'description'}
                  placeholder={'Add a Note...'}
                  value={noteData.description}
                  handleChange={handleChangeFormNote}
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                  // errormsg={errormsg?.description}
                />
              </div>
              <div className="sendActionbtn">
                <button
                  type="button"
                  className="btn btn-primary btnSend roundspin"
                  onClick={() => handleSubmit(noteData)}
                  disabled={!noteDataEdited || loading}
                >
                  {!loading && (
                    <svg
                      width="20px"
                      height="20px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="Arrow / Arrow_Up_MD">
                        <path
                          id="Vector"
                          d="M12 19V5M12 5L6 11M12 5L18 11"
                          stroke="#fff"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                    </svg>
                  )}

                  {loading && (
                    <>
                      {' '}
                      <div className="spinner-border spinner-border-sm " role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Formik>
    </>
  );
};

export default NoteForm;
